import * as React from 'react'
import styled from 'styled-components'
import backArrow from '../img/back-arrow.png'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface IProps extends RouteComponentProps<{}> {}

const NotFound : React.SFC<IProps> = ({history}) => {

  function goBack() {
    history.goBack()
  }

  return (
    <Outer>
      <h1>That page doesn't exist!</h1>
      <div onClick={goBack}>
        <img src={backArrow} alt="go back" />
        <p>Take me back</p>
      </div>
    </Outer>
  )
}

const Outer = styled.div`
  text-align: center;
  margin-top: 150px;

  p {
    font-size: 12px;
    color: grey;
  }

  > div {
    cursor: pointer;
  }
`

export default withRouter(NotFound)



// WEBPACK FOOTER //
// ./src/core/NotFound.tsx